<template>
  <div class="analytics" v-if="active">
    <div class="common-global-range">
      <global-range />
    </div>

    <statistic/>

    <publications-by-source/>

    <publications-by-source-and-gsm/>

    <tonal-post/>

    <tonal-comment />
    <dynamic-by-source/>

    <dynamic-by-source-and-gsm :socialList="socialList"/>
  </div>
</template>

<script>
/*
  common component from tabs directory of analytics
*/

// components
import Statistic from "./components/Statistic";
import PublicationsBySource from "./components/PublicationsBySource";
import TonalPost from "./components/TonalPost";
import TonalComment from "./components/TonalComment";
import PublicationsBySourceAndGsm from "./components/PublicationsBySourceAndGsm";
import DynamicBySource from "./components/DynamicBySource";
import DynamicBySourceAndGsm from "./components/DynamicBySourceAndGsm";
import GlobalRange from "../../../../../../components/commonPeriodRange/GlobalPeriodRange";

// vuex
import { mapGetters } from "vuex";

import {FIRST_TRUST_HOURLY} from "../../../../../../store/actions/analytics";

export default {
  name: "Common",
  computed: {
    ...mapGetters([
      "socialList",
    ]),
  },
  props: {
    active: {
      type: Boolean
    }
  },
  methods: {
    changeSocialList(val) {
      if (this.socialList.includes(val)) {
        if (this.socialList.length > 1) {
          this.socialList = this.socialList.filter(item => item !== val);
        }
      } else {
        this.socialList.push(val);
      }
    }
  },
  // beforeMount() {
  //   console.log('test 1')
  //   console.log('FIRST_TRUST_HOURLY beforeMount', FIRST_TRUST_HOURLY)
  //   this.$store.dispatch(FIRST_TRUST_HOURLY, {thread: this.$route.params.threadId});
  // },
  components: {
    Statistic,
    PublicationsBySource,
    TonalPost,
    TonalComment,
    PublicationsBySourceAndGsm,
    DynamicBySource,
    DynamicBySourceAndGsm,
    GlobalRange
  },
};
</script>

<style>
.analytics {
  padding-top: 29px;
}

.common-global-range {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  margin-right: 20px;
}
@media screen and (max-width: 480px) {
  canvas {
  max-width: 90vw;
  }
}
</style>
